import { useAddETSTicketCommentMutation } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import { useUploadETSAttachments } from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import AttachmentsPreview from 'gcs-common/components/AttachmentsPreview/AttachmentsPreview';
import EtsMessageInput from 'gcs-common/components/EtsMessageInput/EtsMessageInput';
import { useAttachmentsInput } from 'gcs-common/hooks/useAttachmentsInput';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router';
import type { TicketCommentFormValues } from '../TicketDetails/TicketDetails';

const TicketCommentForm = () => {
  const form = useFormContext<TicketCommentFormValues>();
  const addETSTicketComment = useAddETSTicketCommentMutation();
  const uploadETSAttachments = useUploadETSAttachments();
  const { routeTicketId } = useParams();
  const ticketId = routeTicketId ?? '';

  useEffect(() => {
    form.reset({
      comment: '',
      attachments: [],
    });
  }, [ticketId]);

  const onSubmit = async (data: TicketCommentFormValues) => {
    await addETSTicketComment.mutateAsync({
      path: { ticket_id: ticketId },
      body: { body: data.comment.trim() },
    });

    if (data.attachments?.length) {
      await uploadETSAttachments.uploadFiles(ticketId, data.attachments);
    }

    form.reset();
  };

  const { handleFileChange } = useAttachmentsInput(form);

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className="flex h-full flex-col gap-2">
      <AttachmentsPreview handleFileChange={handleFileChange} />

      <EtsMessageInput
        handleFileChange={handleFileChange}
        isSubmitting={addETSTicketComment.isPending || uploadETSAttachments.isPending}
      />
    </form>
  );
};

export default TicketCommentForm;
